//@ts-nocheck

import isHotkey from 'is-hotkey'
import { Registry } from '@react-registry'
import { Editor, Range, Transforms, Node } from 'slate'

import { indentMultipleListItems, outdentMultipleListItems } from '../elements/Element/list/ListItem/utils'
import { insertRowAtEnd } from '../elements/Element/table/utils/insertRowAtEnd'

export const handleSoftBreak = ({ editor, event }) => {
  if (isHotkey('tab', event)) {
    event.preventDefault()

    const { selection } = editor

    if (selection) {
      const [li] = Editor.nodes(editor, {
        match: (n) => n.type === 'li',
        mode: 'lowest'
      })
      const [cell] = Editor.nodes(editor, {
        match: (n) => n.type === 'td' || n.type === 'th',
        mode: 'lowest'
      })

      if (li && ((Range.isCollapsed(selection) && selection.anchor.offset === 0) || Range.isExpanded(selection))) {
        indentMultipleListItems(editor)
      }
      else if (cell) {
        const [table] = Editor.nodes(editor, {
          match: (n) => n.type === 'table',
          mode: 'lowest'
        })
        const [row] = Editor.nodes(editor, {
          match: (n) => n.type === 'tr',
          mode: 'lowest'
        })
        const [rowParent] = Editor.nodes(editor, {
          match: (n) => n.type === 'tbody' || n.type === 'thead',
          mode: 'lowest'
        })
        const nextCell = Editor.next(editor, {
          match: (n) => ['td', 'th'].includes(n.type) && !editor.isVoid(n),
          mode: 'lowest',
          at: cell[1],
        })
        if (table && rowParent && row) {
          if (nextCell) {
            Transforms.select(editor, nextCell[1])
            return
          }
          insertRowAtEnd(editor, table[1])
          handleSoftBreak({ editor, event })
          return
        }
      } else {
        editor.insertText('\t')
      }
    }
  }

  if (isHotkey('shift+enter', event)) {
    event.preventDefault()
    if (editor.csBreakLineOnEnter) {
      Transforms.insertNodes(editor, { type: 'p', children: [{ text: '' }] }, { at: editor.selection, select: true })
      return;
    }
    editor.insertText('\n')
  }

  if (isHotkey('shift+tab', event)) {
    event.preventDefault()

    const { selection } = editor

    if (selection) {
      const [li] = Editor.nodes(editor, {
        match: (n) => (n as any).type === 'li',
        mode: 'lowest'
      });

      if (li) {
        outdentMultipleListItems(editor)
      }
    }
  }
}

Registry.register(handleSoftBreak, {
  id: 'softbreak',
  registry: 'keydown'
})
